export const CODEX_DOCS_URL = 'https://help.cleanlab.ai/codex/'
